import { ReactElement, useContext } from 'react'
import { Table } from 'antd'
import { HtsFormContext } from '@Orders/OrderDetailsPage/context'

import styles from '../styles.css'
import { salesOrder_salesOrder_salesOrderLines_items as SalesOrderLineItemType } from '../Queries/__generated__/salesOrder'

import HTSFormFooter from './HTSFormFooter'
import HTSFormColumns, { ColumnPropType } from './HTSFormColumns'
interface PropType {
    errors: {}
    invalid: boolean
    isAllHtsValuesSubmitted: boolean
    onPreSubmit: Function
    pristine: boolean
    salesOrderLines: SalesOrderLineItemType[]
    saveAndSubmitLater: Function
    selectedValues: {}
    submitting: boolean
    typeOfHts: string
    validationForHtsCode: Function
    isHTSSubmissionTimeExpired: boolean
}

export default function HTSForm(props: PropType) {
    const {
        errors,
        invalid,
        isAllHtsValuesSubmitted,
        onPreSubmit,
        pristine,
        salesOrderLines,
        saveAndSubmitLater,
        selectedValues,
        submitting,
        typeOfHts,
        validationForHtsCode,
        isHTSSubmissionTimeExpired,
    } = props

    const { isImOrder, isAnylineWithProcessName } = useContext(HtsFormContext)
    const orderLines = isImOrder
        ? salesOrderLines.filter(
              item =>
                  item.processName?.toLowerCase() !==
                      'injection molding tooling' &&
                  item.processName?.toLowerCase() !==
                      'injection molding tooling change' &&
                  item.processName?.toLowerCase() !==
                      'compression molding tooling' &&
                  item.processName?.toLowerCase() !==
                      'compression molding tooling change',
          )
        : salesOrderLines

    const getColumns = (): ColumnPropType[] => {
        const HTSFormColumnsProps = {
            isAllHtsValuesSubmitted,
            typeOfHts,
            validationForHtsCode,
        }

        return HTSFormColumns(HTSFormColumnsProps, isHTSSubmissionTimeExpired)
    }

    const getFooter = (): ReactElement => {
        return (
            <HTSFormFooter
                errors={errors}
                invalid={invalid}
                isAnylineWithProcessName={isAnylineWithProcessName}
                onPreSubmit={onPreSubmit}
                pristine={pristine}
                salesOrderLines={orderLines}
                saveAndSubmitLater={saveAndSubmitLater}
                selectedValues={selectedValues}
                submitting={submitting}
                typeOfHts={typeOfHts}
                isHTSSubmissionTimeExpired={isHTSSubmissionTimeExpired}
            />
        )
    }

    return (
        <form>
            <Table
                className={styles.tableStyle}
                columns={getColumns() || []}
                dataSource={orderLines || []}
                footer={!isAllHtsValuesSubmitted ? getFooter : undefined}
                pagination={false}
                rowClassName={() => styles.tableStyleFocus}
                rowKey="id"
                scroll={{
                    x: 'max-content',
                    y: 'max-content',
                }}
            />
        </form>
    )
}
